import { getOrganisationRoleSelectOptions } from '@infuse/api/iam/organisation';
import { useGenericRoleSelectOptions } from '@infuse/iam/role/queries';
import { ref } from 'vue';

export const useOrganisationRoleSelectOptions = () => {
  const fetchOrganisationId = ref<string | undefined>();

  return {
    ...useGenericRoleSelectOptions({
      apiFn: getOrganisationRoleSelectOptions,
      queryKeys: ['roles', 'organisation', 'selectOptions'],
      fetchParentId: fetchOrganisationId,
      onlyEnableWithParentId: true
    }),
    fetchOrganisationId
  };
};
